<template>
  <div class="container">
    <r-process :dataArr="processData"></r-process>
    <el-card shadow="never" class="card">
      <span>Trans # {{ this.$route.query.bpmId }}</span>
      <span v-if="isFlashPush" style="margin-left: 8px; color: #ff6600;">(Flash)</span>
    </el-card>
    <el-card shadow="never" class="card" header="BASIC INFORMATION">
      <customize-form-info
        ref="userInfoForm"
        :infoData="_basicInfoData"
        :isExtra="true"
      >
        <template v-slot:cosnameSlot>
          <span class="customerId" @click="goSnapShot(companydata)">
            {{ companydata.name }}
          </span>
        </template>
      </customize-form-info>
    </el-card>
    <el-card shadow="never" class="card" v-if="isJapan" header="JAPAN">
      <customize-form-info
        ref="japanInfoForm"
        :infoData="_japanInfo"
      ></customize-form-info>
    </el-card>
    <el-card
      shadow="never"
      class="card"
      v-if="this.auditStatus !== 5"
      header="RISK MITIGATION"
    >
      <customize-form-info
        v-for="(item1, index) in riskInfo1"
        :key="index"
        ref="riskInfoForm"
        :infoData="
          item1.map(item => ({
            key: transLabelToName(item.key),
            value:
              item.key === 'collateralAmount'
                ? $utils.formatAmount(item.value)
                : item.value,
          }))
        "
      ></customize-form-info>
      <customize-form-info
        v-for="(item2, index) in riskInfo2"
        :key="index"
        ref="riskInfoForm"
        :infoData="
          item2.map(item => ({
            key: transLabelToName(item.key),
            value:
              item.key === 'insuranceAmount'
                ? $utils.formatAmount(item.value)
                : item.value,
          }))
        "
      ></customize-form-info>
    </el-card>
    <el-card shadow="never" class="card" header="FINANCIAL SCORES">
      <customize-form-info
        :infoData="_scoreInfo"
        v-if="this.auditStatus !== 5"
      ></customize-form-info>
    </el-card>
    <el-card shadow="never" class="card" header="RECENT CREDITLINE">
      <customize-form-info
        :infoData="_creditLineInfo"
        v-if="this.auditStatus !== 5"
      ></customize-form-info>
      <!-- <div v-if="this.auditStatus !== 5">
        <div v-for="(item, index) in historyAmount" :key="index">
          <el-row :gutter="24">
            <el-col :span="12" class="fact-col">
              <span>Credit Request Type：</span>
              <span>{{ item.requestTypeStr }}</span>
            </el-col>
            <el-col :span="12" class="fact-col">
              <span>Credit Category：</span>
              <span>{{ item.typeStr }}</span>
            </el-col>
            <el-col :span="12" class="fact-col">
              <span>Expire Date：</span>
              <span>
                {{ item.indateEnd }}
              </span>
            </el-col>
            <el-col :span="12" class="fact-col">
              <span>Credit Limit Amount：</span>
              <span>
                {{ $utils.formatAmount(item.amount) }}
              </span>
            </el-col>
          </el-row>
        </div>
      </div> -->
    </el-card>
    <el-card shadow="never" class="card" header="REQUESTOR COMMENTS">
      <html-content :content="content" :token="token" />
      <customize-form
        :isShowForm="true"
        :schema="submitFormModel"
        ref="submitterComments"
      >
        <template v-slot:fileListSlot v-if="submitterFileList.length">
          <p
            class="fileItem"
            @click="fileClick(item)"
            v-for="(item, index) in submitterFileList"
            :key="index"
          >
            <i class="el-icon-document"></i>
            {{ item.name }}
          </p>
        </template>
      </customize-form>
    </el-card>
    <el-card shadow="never" class="card" header="CREDIT ANALYST COMMENTS">
      <quill-editor
        ref="quillEditor"
        :initContent="analystComments"
        :token="token"
        :audit-status="this.auditStatus"
        v-if="this.auditStatus !== 5"
      ></quill-editor>
      <customize-form
        :isShowForm="true"
        :schema="commentsModel"
        ref="analysisComments"
        :disabled="this.auditStatus === 3 || this.auditStatus === 4"
        v-if="this.auditStatus !== 5"
      >
        <template
          v-slot:uploadSlot
          v-if="this.auditStatus === 3 || this.auditStatus !== 4"
        >
          <div>
            <el-upload
              ref="upload"
              :action="uploadUrl"
              :headers="{ Authorization: $store.state.token }"
              :auto-upload="true"
              :show-file-list="true"
              :on-exceed="handleNewBeyond"
              :limit="15"
              :on-preview="handlePreview"
              :on-change="handleAnaChange"
              :before-remove="beforeRemove"
              :on-remove="handleRemove"
              :file-list="anaFileList"
              :data="{ type: anaForm.type }"
              :on-success="anaUploadSuccess"
            >
              <customize-button class="upload">Add Attachment</customize-button>
            </el-upload>
            <div
              style="
                position: absolute;
                top: 20px;
                right: 0;
                display: flex;
                flex-direction: column;
                gap: 10px;
              "
            >
              <p style="font-size: 14px">Updated by: {{ analystUpdatedBy }}</p>
              <p style="font-size: 14px">
                Updated Date: {{ analystUpdatedDate }}
              </p>
            </div>
          </div>
        </template>
      </customize-form>
      <div class="up" v-if="this.auditStatus === 4">
        <p
          class="fileItem"
          @click="fileClick(item)"
          v-for="(item, index) in anaFileList"
          :key="index"
        >
          <i class="el-icon-document"></i>
          {{ item.name }}
        </p>
      </div>
    </el-card>
    <el-card shadow="never" class="card" header="REQUEST DETAIL">
      <customize-form
        ref="requestDetailForm"
        :schema="requestDetailModel"
        v-if="this.auditStatus !== 5 && this.running !== 2"
      >
        <template>
          <customize-button
            type="primary"
            @click="handleProcess"
            :loading="isLoading"
          >
            Process
          </customize-button>
        </template>
      </customize-form>
      <customize-form-info
        :infoData="_requestDetailInfo"
        v-else
      ></customize-form-info>
    </el-card>
    <el-card shadow="never" class="card" header="DECISIONS">
      <customize-form
        ref="decisionForm"
        :schema="decisionFormModel"
        :disabled="this.auditStatus === 3 || this.auditStatus === 4"
        v-if="this.auditStatus !== 5"
      >
        <p style="font-size: 14px; margin-bottom: 20px">Comments:</p>
        <quill-editor
          ref="decisionComments"
          :initContent="decisionComment"
          :token="token"
          :audit-status="this.auditStatus"
          v-if="this.auditStatus !== 5"
        ></quill-editor>
        <template
          v-slot:uploadSlot
          v-if="this.auditStatus === 3 || this.auditStatus !== 4"
        >
          <el-upload
            ref="uploadDecision"
            :action="uploadUrl"
            :headers="{ Authorization: $store.state.token }"
            :limit="5"
            :on-exceed="handleBeyond"
            :auto-upload="true"
            :on-preview="handlePreview"
            :before-remove="beforeRemove"
            :on-remove="handleDecRemove"
            :show-file-list="true"
            :on-change="handleDecisionChange"
            :file-list="decisionFileList"
            :on-success="decisionUploadSuccess"
          >
            <customize-button class="upload">Add Attachment</customize-button>
          </el-upload>
        </template>
      </customize-form>
      <div class="up" v-if="this.auditStatus === 4">
        <p
          class="fileItem"
          @click="fileClick(item)"
          v-for="(item, index) in decisionFileList"
          :key="index"
        >
          <i class="el-icon-document"></i>
          {{ item.name }}
        </p>
      </div>
    </el-card>

    <div
      class="btnArea"
      v-if="
        this.auditStatus === 1 ||
        this.auditStatus === 2 ||
        this.auditStatus === 7
      "
    >
      <customize-button
        type="primary"
        @click="handleUpdate"
        :loading="isLoading"
      >
        {{
          this.running === 1
            ? 'Update Decision'
            : this.running === 2
            ? 'Update'
            : ''
        }}
      </customize-button>
      <template v-if="this.running === 1">
        <customize-button type="primary" @click="handleSave" class="botBtn">
          Save
        </customize-button>
        <customize-button @click="showResign = true">Reassign</customize-button>
      </template>
    </div>
    <el-dialog title="Reassign" :visible.sync="showResign" width="480px">
      <customize-form ref="resignForm">
        <template v-slot:vagueSearch>
          <el-select
            v-model="reassignForm.reassignName"
            filterable
            remote
            reserve-keyword
            placeholder="Search"
            :remote-method="remoteActiveName"
            style="width: 100%; margin-bottom: 20px"
          >
            <el-option
              v-for="item in optionsActiveName"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </customize-form>
      <div class="btnArea">
        <customize-button @click="reassignCancel">Cancel</customize-button>
        <customize-button type="primary" @click="handleResign">
          Reassign
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RProcess from '../../../components/r-process/r-process'
import config from '@/config'
import { ERR_OK } from '@/utils/request'
import mixins from '../mixins/mixins'
import htmlContent from './html-content'
import quillEditor from 'components/quill-editor/QuillEditor.vue'
import {
  getAuditDetail,
  getCusInfo,
  saveAuidt,
  completedUpdateAudit,
  completingUpdateAudit,
  resignAudit,
  getFile,
  vagueActiveName,
  creditSubmit,
  getAddlog,
} from './api'
import dayjs from 'dayjs'

const eaasType = {
  label: 'EaaS Type',
  type: 'select',
  key: 'eaasType',
  placeholder: 'All',
  selectList: [
    {
      id: 1,
      name: 'CAPEX',
    },
    {
      id: 2,
      name: 'OPEX',
    },
  ],
  rules: [
    {
      required: true,
      message: 'Cannot be empty',
      trigger: 'change',
    },
  ],
}

export default {
  name: 'credit-audit',
  components: { RProcess, htmlContent, quillEditor },
  mixins: [mixins],
  data() {
    const basicInfoKeys = [
      'code',
      'name',
      'businessStr',
      'countryStr',
      'regionStr',
      'paymentTermReq',
      'customerType',
    ]
    const outerKeys = ['totalAR', 'totalBacklog', 'totalExposure']
    const companyDetailKeys = [
      'averageOverdueRatioLast12',
      'overdueAmount60',
      'paytrendOrAverageAging',
      'globalCustomerRating',
    ]
    const japanKeys = [
      'totalOverdueAmt60',
      'tdbRating',
      'latestFYTotalProfit',
      'latestFDate',
      'latestFYTotalRevenue',
      'latestFYTotalCapital',
    ]
    const riskKeys1 = [
      'collateralAmount',
      'collateralCategoryStr',
      'expirationDate',
      'currency',
    ]
    const riskKeys2 = [
      'insuranceAmount',
      'insuranceProviderStr',
      'expirationDate',
      'currency',
    ]
    const scoreKeys = [
      'sp',
      'moodysStr',
      'fitchStr',
      'frisk',
      'zscore',
      'zscoreSecond',
      'scoreCard',
      'theoreticalLimit',
    ]
    const submitFormModel = [
      // {
      //   key: 'submitterComment',
      //   label: '',
      //   type: 'textarea',
      //   readonly: true,
      //   disabled: true,
      //   rules: [
      //     {
      //       min: 0,
      //       max: 20000,
      //       message: 'No more than 20000 characters.',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
    ]
    const commentsModel = [
      // {
      //   key: 'creditAnalysisComment',
      //   label: '',
      //   type: 'textarea',
      //   value: '',
      //   rules: [
      //     {
      //       min: 0,
      //       max: 20000,
      //       message: 'No more than 20000 characters.',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
    ]
    const creditLineKeys = ['typeStr', 'indateEnd', 'amount', 'requestTypeStr']
    const requestDetailModel = [
      {
        label: 'Credit Request Type',
        type: 'select',
        disabled: true,
        key: 'requestType',
        defaultValue: 1,
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        selectList: [
          {
            id: 1,
            name: 'Line Of Credit',
          },
        ],
      },
      {
        label: 'Credit Type',
        type: 'select',
        value: '',
        disabled: false,
        selectList: [
          { id: 1, name: 'BAU' },
          { id: 2, name: 'Uplift' },
          { id: 3, name: 'Extension' },
        ],
        key: 'type',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      {
        label: 'Request Amount($)',
        type: 'input',
        key: 'amount',
        value: '',
        input: value3 => this.handleProcessChange(value3),
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
    ]
    const decisionFormModel = [
      {
        label: 'Credit Request Type',
        type: 'select',
        key: 'requestType',
        defaultValue: 1,
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        selectList: [
          {
            id: 1,
            name: 'Line Of Credit',
          },
        ],
      },
      {
        label: 'Customer Type',
        type: 'select',
        key: 'customerType',
        placeholder: 'All',
        change: this.handleCustomerTypeChange,
        disabled: true,
        selectList: [
          {
            id: 1,
            name: 'Trade',
          },
          {
            id: 2,
            name: 'Eaas',
          },
          {
            id: 3,
            name: 'Saas',
          },
        ],
        rules: [
          {
            required: true,
            message: 'Cannot be empty',
            trigger: 'change',
          },
        ],
      },
      {
        label: 'Credit Category',
        type: 'select',
        value: '',
        disabled: false,
        selectList: [
          { id: 1, name: 'BAU' },
          { id: 2, name: 'Uplift' },
          { id: 3, name: 'Extension' },
        ],
        key: 'type',
        isSelf: true,
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      {
        label: 'Approved Limit ',
        type: 'input',
        key: 'amount',
        isSelf: true,
        input: value => this.handleChange(value),
        value: '',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      {
        label: 'Partial Amount',
        type: 'input',
        key: 'partialAmount',
        isSelf: true,
        input: value2 => this.handleValueChange(value2),
        value: '',
      },
      {
        style: { display: 'block' },
        label: 'Decision Type',
        disabled: false,
        type: 'select',
        value: '',
        key: 'decisionType',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        selectList: [
          { id: 1, name: 'Manual Approved' },
          { id: 2, name: 'Declined' },
          { id: 3, name: 'Pending' },
          { id: 5, name: 'Cancelled' },
        ],
      },
      {
        value: '',
        label: 'Expire Date',
        isSelf: false,
        type: 'date',
        key: 'indateEnd',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      // {
      //   value: '',
      //   label: 'Comments',
      //   type: 'textarea',
      //   key: 'decisionComments',
      //   rules: [
      //     {
      //       min: 0,
      //       max: 20000,
      //       message: 'No more than 20000 characters.',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
    ]
    return {
      isLoading: false,
      uploadUrl: `${config.baseApi}/workflow-api/credit-apply/attachment/upload`,
      allInfo: {},
      basicInfoKeys,
      basicInfoData: [],
      companyId: '',
      outerKeys,
      outsideInfo: [],
      auditDetail: [], // current credit line 字段
      companyDetailKeys,
      companyDetailInfo: [],
      isJapan: false, // 是否是日本公司
      japanInfo: [],
      japanKeys, // 日本公司数据info
      riskKeys1,
      riskKeys2,
      bpmId: this.$route.query.bpmId,
      riskInfo1: [], // risk info & keys
      riskInfo2: [], // risk info & keys
      scoreKeys,
      scoreInfo: [], // score info & keys
      creditLineKeys,
      companydata: [],
      historyAmount: [],
      creditLineInfo: [], // credit line info & keys
      requestDetailInfo: [], // request detail info & keys
      submitFormModel,
      commentsModel,
      decisionFormModel,
      requestDetailModel,
      processData: [],
      showResign: false,
      anaFileList: [], // ana 上传文件列表
      decisionFileList: [], // decision 上传文件列表
      anaForm: { type: '' },
      submitterFileList: [], // submitter 文件列表
      auditStatus: 0,
      indateEnd: '',
      running: '',
      // 审核的状态，1-WQ(pending)(3btn)；2-Success(manualapp)(1btn-Update)；3-Reject&4-Cancel(0btn);5-AutoRules(0btn3info+submit&files)
      showBtnArea: true,
      reassignForm: {
        reassignName: '',
      },
      optionsActiveName: [], //reassign active name
      content: '',
      analystComments: '',
      decisionComment: '',
      token: '',
      oldAnalystComments: '',
      analystUpdatedBy: '',
      analystUpdatedDate: '',
      isFlashPush: false,
    }
  },
  computed: {
    _basicInfoData() {
      const data = [
        ...this.basicInfoData,
        ...this.outsideInfo,
        ...this.auditDetail,
        ...this.companyDetailInfo,
      ].map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = [
          'Total AR',
          'ValidAmount',
          'Average Overdue Ratio in last 12 mths(%)',
          'Overdue Amount >= 60 Days',
          'Total Exposure',
          'Total Backlog',
        ]
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        if (item.key === 'Customer Type') {
          item.value =
            item.value === 1 ? 'Trade' : item.value === 2 ? 'Eaas' : 'Saas'
        }

        return item
      })

      return data
    },
    _japanInfo() {
      return this.japanInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = [
          'Latest Financial Year Total Profit',
          'Latest Financial Year Total Revenue',
          'Overdue Amount >= 60 Days',
          'Total Overdue AMT >= 60 Days',
          'Latest Financial Year Total Capital',
        ]
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _scoreInfo() {
      return this.scoreInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = ['Theoretical Limit']
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _creditLineInfo() {
      return this.creditLineInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        if (item.key === 'Credit Limit Amount') {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _requestDetailInfo() {
      return this.requestDetailInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        if (item.key === 'Request Amount($)') {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
  },
  mounted() {
    const auditParams = {
      bpmId: this.$route.query.bpmId,
    }
    this.getAuditDetail(auditParams)
    // 如果source是CSS, 那么DECISION Form下的credit request type 选项中不带other
    if (this.$route.query.source === 'CSS') {
      this.decisionFormModel = this.decisionFormModel.map(item => {
        if (item.key === 'requestType') {
          item.selectList.push({ id: 2, name: 'Other' })
        }
        return item
      })
    }
    this.token = this.$storage.getItem('token')
  },
  beforeDestroy() {
    document.title = 'Lenovo Credit Platform'
  },
  methods: {
    handleCustomerTypeChange(val) {
      if (val === 2) {
        this.decisionFormModel.splice(2, 0, eaasType)
      } else if (val !== 2 && this.decisionFormModel.length === 8) {
        this.decisionFormModel.splice(2, 1)
      }
    },
    async handleChange(value) {
      value = this.$utils.setSeperatenum(value)
      this.decisionFormModel = this.decisionFormModel.map(item => {
        if (item.key === 'amount') {
          item.value = value
        }
        return item
      })
    },
    async handleValueChange(value2) {
      value2 = this.$utils.setSeperatenum(value2)
      this.decisionFormModel = this.decisionFormModel.map(item => {
        if (item.key === 'partialAmount') {
          item.value = value2
        }
        return item
      })
    },
    async handleProcessChange(value3) {
      value3 = this.$utils.setSeperatenum(value3)
      this.requestDetailModel = this.requestDetailModel.map(item => {
        if (item.key === 'amount') {
          item.value = value3
        }
        return item
      })
    },
    async handleProcess() {
      this.isLoading = true
      try {
        const { requestType, type, amount } =
          this.$refs.requestDetailForm.getFormData()
        const params = {
          attachmentIds: [],
          remark: '',
          requestType: requestType,
          type: type,
          loanAmount: {
            amount: this.$utils.resetAmount(amount),
          },
          bpmId: this.$route.query.bpmId,
          companyId: this.companyId,
          dunsNumber: '',
        }
        await creditSubmit(params)
        this.$message.success('success')
        this.isLoading = false
        await this.$router.push('/credit-management/credit-request/query')
      } catch (err) {
        this.isLoading = false
        console.error(err)
      }
    },
    async goSnapShot(data) {
      await this.$storage.setItem('customerInfo', {
        name: data.name,
        address: data.address,
        code: data.code,
        country: data.countryStr,
        city: data.city,
        state: data.state,
      })
      let routeUrl = this.$router.resolve({
        path: `/customer-management/${data.id}/info/snapshot`, // 对应路由
      })
      window.open(routeUrl.href, '_blank')
      const params = {
        companyId: data.id,
      }
      await getAddlog(params)
    },
    async getAuditDetail(params) {
      try {
        const res = await getAuditDetail(params)
        console.log(res)

        // ----- 获取此审核的status，赋值给this.auditStatus
        this.auditStatus = res.creditInfo.status
        this.companyId = res.creditInfo.companyId
        if (res.creditInfo.status === 7) {
          this.decisionFormModel = this.decisionFormModel.map(item => {
            if (item.key === 'decisionType') {
              item.style.display = 'none'
            }
            return item
          })
        }
        this.indateEnd = res.creditInfo.indateEnd

        if (this.auditStatus === 2) {
          this.decisionFormModel = this.decisionFormModel.map(item => {
            if (item.key === 'decisionType') {
              item.disabled = true
            }
            return item
          })
        }
        this.running = res.running
        // 回显CREDIT ANALYST COMMENTS

        this.analystUpdatedBy = res.creditInfo.analystUpdatedBy
        this.analystUpdatedDate = res.creditInfo.analystUpdatedDate
        if (
          res.creditInfo.creditAnalystComments.includes('&gt;') ||
          res.creditInfo.creditAnalystComments.includes('&lt;') ||
          res.creditInfo.creditAnalystComments.includes('\n')
        ) {
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/&lt;/g, '<')
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/&gt;/g, '>')
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/\n/g, '<br/>')
        }
        this.analystComments = res.creditInfo.creditAnalystComments
        this.oldAnalystComments = res.creditInfo.creditAnalystComments

        if (
          res.creditInfo.decisionComments.includes('&gt;') ||
          res.creditInfo.decisionComments.includes('&lt;') ||
          res.creditInfo.decisionComments.includes('\n')
        ) {
          res.creditInfo.decisionComments =
            res.creditInfo.decisionComments.replace(/&lt;/g, '<')
          res.creditInfo.decisionComments =
            res.creditInfo.decisionComments.replace(/&gt;/g, '>')
          res.creditInfo.decisionComments =
            res.creditInfo.decisionComments.replace(/\n/g, '<br/>')
        }
        this.decisionComment = res.creditInfo.decisionComments
        this.commentsModel = [
          // {
          //   key: 'creditAnalysisComment',
          //   label: '',
          //   type: 'textarea',
          //   value: res.creditInfo.creditAnalystComments,
          //   rules: [
          //     {
          //       min: 0,
          //       max: 20000,
          //       message: 'No more than 20000 characters.',
          //       trigger: 'blur',
          //     },
          //   ],
          // },
        ]
        // 回显decision的textarea
        // 抽出decisions form需要回显的数据
        const _decisionKeys = Object.keys(res.creditInfo)
        const _decisionFormModel = this.decisionFormModel.map(item => {
          if (_decisionKeys.indexOf(item.key) !== -1) {
            item.value = res.creditInfo[item.key]
            if (item.key === 'indateEnd' && !item.value) {
              item.value = dayjs().subtract(-1, 'year').format('YYYY-MM-DD')
            }
            if (item.key === 'decisionComments') {
              if (
                item.value.includes('&gt;') ||
                item.value.includes('&lt;') ||
                item.value.includes('\n')
              ) {
                item.value = item.value.replace(/&lt;/g, '<')
                item.value = item.value.replace(/&gt;/g, '>')
                item.value = item.value.replace(/\n/g, '<br/>')
              }
            }
            item.label === 'Approved Limit ' || item.label === 'Partial Amount'
              ? (item.value = this.$utils.formatAmount(
                  res.creditInfo[item.key],
                ))
              : res.creditInfo[item.key]
          }
          return item
        })
        this.decisionFormModel = _decisionFormModel
        if (res.creditInfo.customerType === 2) {
          this.decisionFormModel.splice(2, 0, {
            ...eaasType,
            value: res.creditInfo.eaasType,
          })
        }

        // -----
        // 回显REQUEST DETAIL需要回显的数据
        this.requestDetailModel = [
          {
            label: 'Credit Request Type',
            type: 'select',
            disabled: true,
            key: 'requestType',
            value: res.creditInfo.requestType,
            rules: [
              { required: true, message: 'Can not be empty!', trigger: 'blur' },
            ],
          },
          {
            label: 'Credit Type',
            type: 'select',
            value: res.creditInfo.applyType,
            disabled: false,
            selectList: [
              { id: 1, name: 'BAU' },
              { id: 2, name: 'Uplift' },
              { id: 3, name: 'Extension' },
            ],
            key: 'type',
            isSelf: true,
            rules: [
              { required: true, message: 'Can not be empty!', trigger: 'blur' },
            ],
          },
          {
            label: 'Request Amount($)',
            type: 'input',
            key: 'amount',
            isSelf: true,
            input: value3 => this.handleProcessChange(value3),
            value: this.$utils.formatAmount(res.creditInfo.applyAmount),
            rules: [
              { required: true, message: 'Can not be empty!', trigger: 'blur' },
            ],
          },
        ]
        // 如果是manual approved decision type 置灰
        if (this.running === 2) {
          const __decisionFormModel = []
          this.decisionFormModel.forEach(item => {
            if (item.key === 'decisionType') {
              item.disabled = true
            }
            __decisionFormModel.push(item)
          })
          this.decisionFormModel = __decisionFormModel
        }
        if (this.running === 1 && this.auditStatus === 5) {
          // 说明正在是auto rules中，此时按钮不显示
          this.showBtnArea = false
        }
        // --- 将ana和decision的文件回显
        this.anaFileList = res.attachments
          .filter(item => item.fileType === 2)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        this.decisionFileList = res.attachments
          .filter(item => item.fileType === 3)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        // ---
        // 取出credit line的信息
        const _auditArr = []
        // const obj = {}
        // obj.key = 'validAmount'
        // obj.value = res['validAmount']
        // _auditArr.push(obj)
        this.auditDetail = _auditArr
        // 操作credit line 数据
        const _creditLine = []
        this.historyAmount = res.historyAmount
        Object.keys(res.historyAmount).forEach(key => {
          if (this.creditLineKeys.indexOf(key) !== -1) {
            const obj = {}
            obj.key = key
            obj.value = res.historyAmount[key]
            _creditLine.push(obj)
          }
        })
        this.creditLineInfo = _creditLine
        // ----- 文件列表
        this.submitterFileList = res.attachments
          .filter(item => item.fileType === 1)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        // -----
        // take request detail
        const _requestDetailInfo = []
        Object.keys(res.creditInfo).forEach(key => {
          if (
            key === 'amount' ||
            key === 'applyTypeStr' ||
            key === 'requestTypeStr'
          ) {
            const _obj = {
              key: key === 'amount' ? 'amountDetail' : key,
              value: res.creditInfo[key],
            }
            _requestDetailInfo.push(_obj)
          }
        })
        this.requestDetailInfo = _requestDetailInfo
        // take process
        this.processData = res.process
        if (this.running === 2) {
          this.decisionFormModel.forEach(item => {
            if (
              item.label === 'Expire Date' &&
              res.creditInfo.customerType === 1
            ) {
              let _this = this
              item.pickerOptions = {
                disabledDate(time) {
                  const year = Number(
                    _this.processData[_this.processData.length - 1].createTime
                      .split(' ')[0]
                      .split('-')[0],
                  )
                  const mon = Number(
                    _this.processData[_this.processData.length - 1].createTime
                      .split(' ')[0]
                      .split('-')[1],
                  )
                  const day = Number(
                    _this.processData[_this.processData.length - 1].createTime
                      .split(' ')[0]
                      .split('-')[2],
                  )
                  const oneYear = year + 1
                  const timeYear = new Date(
                    oneYear + '/' + mon + '/' + day,
                  ).getTime()
                  return time.getTime() > timeYear // time.getTime() < Date.now() - 8.64e7
                },
              }
            }
          })
        } else {
          this.decisionFormModel.forEach(item => {
            if (
              item.label === 'Expire Date' &&
              res.creditInfo.customerType === 1
            ) {
              item.pickerOptions = {
                disabledDate(time) {
                  const year = new Date().getFullYear()
                  const mon = new Date().getMonth() + 1
                  const day = new Date().getDate()
                  const oneYear = year + 1
                  const timeYear = new Date(
                    oneYear + '/' + mon + '/' + day,
                  ).getTime()
                  return time.getTime() > timeYear // time.getTime() < Date.now() - 8.64e7
                },
              }
            }
          })
        }
        //
        if (
          res.creditInfo.remark.includes('&gt;') ||
          res.creditInfo.remark.includes('&lt;') ||
          res.creditInfo.remark.includes('\n')
        ) {
          res.creditInfo.remark = res.creditInfo.remark.replace(/&lt;/g, '<')
          res.creditInfo.remark = res.creditInfo.remark.replace(/&gt;/g, '>')
          res.creditInfo.remark = res.creditInfo.remark.replace(/\n/g, '<br/>')
        }
        this.content = res.creditInfo.remark
        // 判断remark是否以"Flash push"开头
        if (res.creditInfo.remark && res.creditInfo.remark.startsWith('Flash push')) {
          this.isFlashPush = true
        } else {
          this.isFlashPush = false
        }
        this.decisionFormModel.forEach(item => {
          if (item.key === 'indateEnd') {
            const that = this // 保存this引用
            item.pickerOptions = {
              disabledDate(time) {
                if (!that.indateEnd) return false
                const endDate = new Date(that.indateEnd).getTime()
                return time.getTime() > endDate
              },
            }
          }
        })
        // this.submitFormModel = [
        //   {
        //     ...this.submitFormModel[0],
        //     value: res.creditInfo.remark,
        //   },
        // ]
        // 请求工作流审批客户详情
        await this._getCusInfo(res.creditInfo.companyId)
      } catch (err) {
        console.log(err)
      }
    },
    async _getCusInfo(id) {
      try {
        const params = {
          id,
        }
        const res = await getCusInfo(params)
        document.title = res.companyInfoVO.name
        this.companydata = res.companyInfoVO
        this.allInfo = res
        this.filterData(res)
      } catch (err) {
        console.log(err)
      }
    },
    //对数据进行摘取
    filterData(allData) {
      // 如果是日本
      if (allData.companyInfoVO.countryStr === 'Japan') {
        this.isJapan = true
        if (allData.companyJapanDetailVO) {
          const _japanInfo = []
          this.japanInfo = this.handleKeys(
            allData.companyJapanDetailVO,
            _japanInfo,
            this.japanKeys,
          )
        }
      }
      // 对外层数据进行操作，之后合并一起传给r-form
      const _outArr = []
      Object.keys(allData).forEach(key => {
        if (this.outerKeys.indexOf(key) !== -1) {
          const _obj = {}
          _obj.key = key
          _obj.value = allData[key]
          _outArr.push(_obj)
        }
      })
      this.outsideInfo = _outArr
      // 对 customer basic info操作
      if (allData.companyInfoVO) {
        const _basicInfoData = []
        this.basicInfoData = this.handleKeys(
          allData.companyInfoVO,
          _basicInfoData,
          this.basicInfoKeys,
        )
      }
      // 对company detail 数据进行操作
      if (allData.companyDetailVO) {
        const _companyDetailInfo = []
        this.companyDetailInfo = this.handleKeys(
          allData.companyDetailVO,
          _companyDetailInfo,
          this.companyDetailKeys,
        )
      }
      // 对risk数据进行操作
      if (allData.riskMitigationVO) {
        const InsurancesArr = allData.riskMitigationVO.companyInsurances
        const AssurancesArr = allData.riskMitigationVO.companyAssurances
        for (let item = 0; item < AssurancesArr.length; item++) {
          const _item1 = []
          this.riskInfo1.push(
            this.handleKeys(AssurancesArr[item], _item1, this.riskKeys1),
          )
        }
        for (let index = 0; index < InsurancesArr.length; index++) {
          const _riskInfo2 = []
          this.riskInfo2.push(
            this.handleKeys(InsurancesArr[index], _riskInfo2, this.riskKeys2),
          )
        }
      }
      // 对financial scores 进行操作
      if (allData.financialScoresVO) {
        const _scoreInfo = []
        this.scoreInfo = this.handleKeys(
          allData.financialScoresVO,
          _scoreInfo,
          this.scoreKeys,
        )
      }
    },
    // 提出来function handle keys
    handleKeys(dataObj, targetArr, keysArr) {
      Object.keys(dataObj).forEach(key => {
        if (keysArr.indexOf(key) !== -1) {
          const obj = {}
          obj.key = key
          obj.value = dataObj[key]
          targetArr.push(obj)
        }
      })
      return targetArr
    },
    // 底部button事件
    async handleSave() {
      // 处理decision的数据
      const _loanAmount = { ...this.$refs.decisionForm.getFormData() }
      _loanAmount.amount = this.$utils.resetAmount(_loanAmount.amount)
      _loanAmount.partialAmount = this.$utils.resetAmount(
        _loanAmount.partialAmount,
      )
      delete _loanAmount.source
      const obj = JSON.parse(JSON.stringify(_loanAmount))
      if (obj.customerType !== 2) {
        delete obj.eaasType
      }
      delete obj.decisionComments
      const isValid = await this.$refs.decisionForm.validateFields()
      const Valid = await this.$refs.analysisComments.validateFields()
      console.log(Valid)
      if (isValid) {
        const params = {
          attachmentAnalystIds: this.anaFileList.length
            ? this.anaFileList.map(file => file.response?.data || file.id)
            : [],
          attachmentDecisionIds: this.decisionFileList.length
            ? this.decisionFileList.map(file => file.response?.data || file.id)
            : [],
          bpmId: this.$route.query.bpmId,
          creditAnalystComments: this.$refs.quillEditor.getContent().trim(),
          decisionComments: this.$refs.decisionComments.getContent().trim(),
          loanAmount: obj,
        }
        if (params.creditAnalystComments !== this.oldAnalystComments) {
          params.analystChangeMark = 1
          this.oldAnalystComments = params.creditAnalystComments
        } else {
          params.analystChangeMark = 2
        }

        try {
          await saveAuidt(params)
          this.$message.success('success')
        } catch (err) {
          console.log(err)
        }
      }
    },
    async handleUpdate() {
      // 处理decision的数据
      const isValid = await this.$refs.decisionForm.validateFields()
      const Valid = await this.$refs.analysisComments.validateFields()
      console.log(Valid)
      if (isValid) {
        this.isLoading = true
        const _loanAmount = { ...this.$refs.decisionForm.getFormData() }
        _loanAmount.amount = this.$utils.resetAmount(_loanAmount.amount)
        _loanAmount.partialAmount = this.$utils.resetAmount(
          _loanAmount.partialAmount,
        )
        const obj = JSON.parse(JSON.stringify(_loanAmount))
        delete obj.decisionComments
        if (obj.customerType !== 2) {
          delete obj.eaasType
        }
        delete _loanAmount.source
        const params = {
          attachmentAnalystIds: this.anaFileList.length
            ? this.anaFileList.map(file => file.response?.data || file.id)
            : [],
          attachmentDecisionIds: this.decisionFileList.length
            ? this.decisionFileList.map(file => file.response?.data || file.id)
            : [],
          bpmId: this.$route.query.bpmId,
          creditAnalystComments: this.$refs.quillEditor.getContent().trim(),
          decisionComments: this.$refs.decisionComments.getContent().trim(),
          loanAmount: obj,
        }

        if (params.creditAnalystComments !== this.oldAnalystComments) {
          params.analystChangeMark = 1
          this.oldAnalystComments = params.creditAnalystComments
        } else {
          params.analystChangeMark = 2
        }
        try {
          if (this.running === 1) {
            await completingUpdateAudit(params)
          } else {
            await completedUpdateAudit(params)
          }
          this.isLoading = false
          this.$message.success('success')
          await this.$router.push('/credit-management/credit-request/query')
        } catch (err) {
          this.isLoading = false
          console.log(err)
        }
      }
    },
    // 派发
    async handleResign() {
      try {
        const params = {
          assignTo: this.reassignForm.reassignName,
          bpmIds: [this.$route.query.bpmId],
        }
        await resignAudit(params)
        this.$message.success('success')
        this.showResign = false
      } catch (err) {
        console.log(err)
      }
    },
    beforeRemove(file) {
      return this.$confirm(`Confirm delete ${file.name}?`)
    },
    handleRemove(file, fileList) {
      this.anaFileList = fileList
    },
    handleDecRemove(file, fileList) {
      this.decisionFileList = fileList
    },
    handleAnaChange(file) {
      if (!file.response) {
        const size = file.size / 1024
        if (size < 50000) {
          this.anaFileList.push(file)
        } else {
          this.$message.error('File must not exceed 50M')
          this.anaFileList = [...this.anaFileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
        }
      }
    },
    anaUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        this.anaFileList.pop()
      }
    },
    handleDecisionChange(file) {
      // 单个文件上传
      if (!file.response) {
        const size = file.size / 1024
        if (size < 50000) {
          this.decisionFileList.push(file)
        } else {
          this.$message.error('File must not exceed 50M')
          this.decisionFileList = [...this.decisionFileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
        }
      }
    },
    decisionUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        this.decisionFileList.pop()
      }
    },
    handleNewBeyond() {
      this.$message.warning('No more than 15 attachments!')
    },
    handleBeyond() {
      this.$message.warning('No more than 5 attachments!')
    },
    async handlePreview(fileList) {
      try {
        const params = {
          id: fileList.id,
        }
        await getFile(params)
      } catch (err) {
        console.log(err)
      }
    },
    async fileClick(fileList) {
      try {
        const params = {
          id: fileList.id,
        }
        await getFile(params)
      } catch (err) {
        console.log(err)
      }
    },
    reassignCancel() {
      this.showResign = false
    },
    // 模糊查询active name
    async remoteActiveName(query) {
      if (query !== '') {
        try {
          const params = {
            name: query,
          }
          const res = await vagueActiveName(params)
          this.optionsActiveName = res.map(item => ({
            id: item.id,
            label: item.username,
            value: item.username,
          }))
        } catch (err) {
          console.log(err)
        }
      } else {
        this.optionsActiveName = []
      }
    },
  },
}
</script>
<style scoped lang="less">
.container {
  width: 100%;
  .customerId {
    color: blue;
    font-size: 14px;
    cursor: pointer;
  }
  .card {
    width: 100%;
    margin-bottom: 24px;
  }
  .fileItem {
    width: 700px;
    cursor: pointer;
    height: 30px;
    font-size: 14px;
  }
  .fileItem:hover {
    color: #409eff;
  }
  .processBox {
    width: 100%;
    height: 190px;
    background-color: yellowgreen;
  }
}
.upload {
  width: 100%;
  margin-top: 20px;
  border-radius: 27px;
}
.process {
  background: #fe7301;
}
.txtArea {
  width: 700px;
  margin-top: 10px;
}
// .process {
//   display: flex;
//   margin-right: 24px;
//   justify-content: flex-end;
// }
.btnArea {
  width: 100%;
  display: flex;
  button {
    margin-right: 24px;
  }
  justify-content: flex-end;
}
</style>
